// Single source for the Assets → Properties `prop_type` option list (FIELD-AUDIT-1 D-154.1 / D-154.8).
// Consumed by BOTH the template spec (shared/template-spec/assets.ts) AND the About You
// "Do you own any other property?" quick-add mini-list (shared/constants/capture-upstream.ts),
// so the two surfaces can never drift again (G7). Order is the rendered order.
export const PROP_TYPE_OPTIONS = [
  "Primary Residence",
  "Secondary Residence",
  // s234 (D-234.39, D-196.1): "Rental Property" RETIRED — whether a place is let is its own answer ("Rented out?",
  // real_estate_assets.rented_out). Stored answers are carried at boot (typeRealEstateV1); the enum value stays, unused.
  "Investment Property",
  "Farm",
  "Vacant Land",
  "Commercial",
  "Timeshare",
  // s232 (chapter two, PR B): the interview's "A cottage or cabin" and "A parking space" (Other property). Before Other.
  "Cottage or Cabin",
  "Parking Space",
  "Other",
] as const;
